import BaseAPI from '../../api'
import { FindAllInterface } from '../../apiModel'

const path = 'bidder-type'

export interface BidderTypeInterface {
    bidTypeId?: number
    bidTypeName : string
    bidTypeNameEn?: string
    status: string
    }

export default class BidderTypeApi extends BaseAPI {
    static findAll(props: FindAllInterface): Promise<any> {
        return this.api.get(path, { params: { ...props } }).then((res) => res)
    }

    static create(bidTypeName: string, bidTypeNameEn: string) {
        return this.api.post(path , { bidTypeName, bidTypeNameEn })
    }

    static findById(id: number): Promise<BidderTypeInterface> {
        return this.api.get(`${path}/${id}`)
    }

    static update(id: number, body: BidderTypeInterface) {
        return this.api.patch(`${path}/${id}`, body)
    }

    static updateStatus(id: number, status: string): Promise<any> {
        return this.api.patch(`${path}/${id}/status`, { id, status })
    }

    static delete(id: number) {
        return this.api.delete(`${path}/${id}`)
    }

}
